import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** SPA aliases must hand off to the same document as a direct www request. */
export function ProxyOwnedLegalDocument({
  path,
}: {
  path: '/polityka-prywatnosci' | '/regulamin';
}) {
  const { search, hash } = useLocation();
  const destination = path + search + hash;
  useEffect(() => {
    window.location.replace(destination);
  }, [destination]);

  return <a href={destination}>Przejdź do dokumentu</a>;
}
